import FontFaceObserver from "fontfaceobserver";
export const init = () => {
  const fontNames = ['FK Grotesk'];
  const timeoutLimit = 10000;

  Promise.all(fontNames.map(fontName => (
    new FontFaceObserver(fontName).load(null, timeoutLimit)
      .catch(() => { throw new Error(`Font '${fontName}' loading error or timeout exceeded.`); })
  )))
    .then(() => {
      console.log('Both fonts loaded successfully.');
    })
    .catch(error => console.error('Font loading error:', error.message))
    .finally(() => document.body.classList.remove('no-visible'));
};